module.exports = __webpack_public_path__ + "img/1.edb6a2b6.jpg";